goog.provide('el8.ptdata.model.note.editableSet');

goog.require('el8.model.base');


/**
 * Base class for sets of items that can be edited
 *
 * IMPORTANT: The model class defined is expected to have "editId" and "replacedByEditId"
 *            int properties
 */
el8.ptdata.model.note.editableSet = function(var_args) {
    el8_EntitySet.apply(this, arguments);
};
el8.ptdata.model.note.editableSet.inheritsFrom(el8_EntitySet);
el8.ptdata.model.note.editableSet.prototype.sorted = function(editId) {

    if (!editId) {
        return this.parent.sorted.apply(this).filter(function(a) {
            return !Boolean(a.getReplacedByEditId());
        });

    } else {
        var sorted = this.parent.sorted.apply(this);
        if (!sorted.length) { return []; }
        // TODO This creates a potential circular dependency that should be removed
        // once the ptdata files are reorg'd
        var note = el8.ptdata.tempVisitNotes.getById(sorted[0].getNoteId()) || 
            el8.ptdata.visitNotes.getById(sorted[0].getNoteId());
        var ordering = note.getEditsOrdering();
        return sorted.filter(function(a) {
            /* If this is an in progress edit, i.e. doesn't exist in the getEditsOrdering(), 
             * then act as if there were no editId! */
            if (ordering[editId] === undefined) { return !Boolean(a.getReplacedByEditId()); }
            if (a.getReplacedById) {
                return Boolean( 
                    // FALSE if bullet belongs to an edit LATER than this edit
                    (!a.getEditId() || (ordering[a.getEditId()] <= ordering[editId])) &&
                    // FALSE if bullet has been replaced in an earlier edit OR
                    //   if in THIS edit BY another bullet (i.e. not a delete)
                    (!a.getReplacedByEditId() || 
                        (ordering[a.getReplacedByEditId()] > ordering[editId]) ||
                        (a.getReplacedByEditId() === editId && !a.getReplacedById()))
                );
            } else {
                return Boolean( 
                    // FALSE if item belongs to an edit LATER than this edit
                    (!a.getEditId() || (ordering[a.getEditId()] <= ordering[editId])) &&
                    // FALSE if item has been replaced in an earlier edit
                    (!a.getReplacedByEditId() || 
                        (ordering[a.getReplacedByEditId()] >= ordering[editId]))
                );
            }
        });
    }
};


el8.ptdata.model.note.editableSet.prototype.all = function(isTrueAll) {
    // For almost all intents and purposes, we only want to see the latest vitals 
    // The *TRUE* all, can be found right now
    if (isTrueAll) {
        return this.parent.all.apply(this);
    } else {
        return this.parent.all.apply(this).filter(function(a) {
            return !Boolean(a.getReplacedByEditId());
        });
    }
};

